// Import action types related to inner gallery data
import {
  GALLARY_INNER_FETCH_DATA_SUCCESS,
  GALLARY_INNER_HAVE_ERROR,
  GALLARY_INNER_ARE_LOADING,
} from "../actionType";

// Define the initial state for the GalleryInnerReducer
const initialState = {
  data: [],
  loading: true,
  error: [], // Initialize error as null for better error handling
};

// Reducer function to handle inner gallery-related actions and update state accordingly
export function GallaryInnerReducer(state = initialState, action) {
  switch (action.type) {
    // Handle error case when fetching inner gallery data
    case GALLARY_INNER_HAVE_ERROR:
      return {
        ...state,
        error: action.hasError, // Update the error state with the error from the action
        loading: false, // Set loading to false since the request is complete
      };

    // Handle loading state when inner gallery data is being fetched
    case GALLARY_INNER_ARE_LOADING:
      return {
        ...state,
        loading: action.isLoading, // Update the loading state with the loading status from the action
      };

    // Handle success case when inner gallery data is successfully fetched
    case GALLARY_INNER_FETCH_DATA_SUCCESS:
      return {
        ...state,
        data: action.GallaryInner, // Update the data state with the fetched inner gallery data
        loading: false, // Set loading to false since the request is complete
        error: null, // Clear any previous errors
      };

    // Return the current state by default if action type is not recognized
    default:
      return state;
  }
}
